export default "./fonts/survio-20wBL-fonts-icomoon.ttf";